export default __webpack_public_path__ + "static/media/skny.d9a82023.png";